(function () {

    'use strict';

    angular.module('iplusjs.iframe.events', [
        'lodash'
    ])
    .directive('iplusjsIframeEvents', iFrameEvents);

    IframeEventsController.$inject = [
        '$element'
    ];
    function IframeEventsController($element) {
        var vm = this;

        vm.$onInit = onInit;
        vm.$onDestroy = onDestroy;

        function onInit() {
            $element.on('load', function () {
                return vm.onLoad({
                    element: $element
                });
            });
        }

        function onDestroy() {
            $element.off('load');
        }
    }

    function iFrameEvents() {
        return {
            restrict: 'A',
            scope: {
                onLoad: '&?iieOnLoad'
            },
            controller: IframeEventsController,
            controllerAs: 'iframeEventsVm',
            bindToController: true
        };
    }
})();
